import { CustomerCompanyMessage } from '../../../../../../types/CustomerCompanyMessage';
import { Text } from '../../../../../cdl/Text/Text';
import { CustomerInfoPopup } from '../../../../../common/CoreDataPopup/CustomerInfoPopup';
import { formatCompanyName } from '../../../../../common/helpers/formatCompanyName.helper';
import { translate } from '../../../../../common/helpers/translate.helper';

import { InvolvedParty } from './InvolvedParty';

interface CustomerPartyProps {
    customer: CustomerCompanyMessage;
    isSpot: boolean;
    isEnquiry: boolean;
}

export const CustomerParty = ({ customer, isSpot, isEnquiry }: CustomerPartyProps) => {
    const isNotSpotEnquiry = !isEnquiry || !isSpot;

    return (
        <InvolvedParty
            label={translate('offer.detail.coreData.customer')}
            modalContent={<CustomerInfoPopup isSpot={isSpot} isEnquiry={isEnquiry} customer={customer} />}
        >
            <Text>
                {formatCompanyName({
                    company: customer,
                })}
            </Text>
            {customer.email && isNotSpotEnquiry ? (
                <Text
                    color="foreground.subtle"
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', textWrap: 'nowrap' }}
                >
                    {customer.email}
                </Text>
            ) : null}
            {customer.phone && isNotSpotEnquiry ? <Text color="foreground.subtle">{customer.phone}</Text> : null}
        </InvolvedParty>
    );
};
